import { ProductCategoryListResponse } from "utils/api/client/types/types"
import {
  CategoryCreateBody,
  CategoryDetailResponse,
  CategoryItem,
} from "../types"

export class ProductCategory {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductCategoryListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/product-categories`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  create(
    vendorId: string,
    body: CategoryCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<CategoryItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/product-categories`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: CategoryCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<CategoryItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/product-categories/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<CategoryDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/product-categories/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/product-categories/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
